<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="BaFinal"></IndexBase>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] BAST Final
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.REVISED&& header.Status != this.$APPROVAL_STATUS.DONE)"/>
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">

                            <FormField :labelName="$t('doc_no')" fieldName="Doc_No" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Doc_No" v-model="header.Doc_No" required="true" type="text"
                                    :placeholder="$t('doc_no')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('no_spo')" fieldName="No_SPO" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && header.No_SPO != null">
                                <InputText name="No_SPO" v-model="header.No_SPO" required="true" type="text"
                                    :placeholder="$t('no_spo')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.No_SPO && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('no_spo')) }}
                                     </small>
                            </FormField>
                            
                            <FormField :labelName="$t('tgl_spo')" fieldName="Tanggal_SPO" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && header.No_SPO != null">
                                <DatePicker name="tgl_spo" v-model="header.Tanggal_SPO" type="text"
                                :placeholder="$t('tgl_spo')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="true"/>
                                <small
                                    v-if="header && !header.Tanggal_SPO && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('tgl_spo')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('work')" fieldName="Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Pekerjaan" v-model="header.Pekerjaan" required="true" type="text"
                                    :placeholder="$t('work')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.Pekerjaan && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('work')) }}
                                     </small>
                            </FormField>

                            <FormField :labelName="$t('completion_time')" fieldName="Waktu_Penyelesaian" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Waktu_Penyelesaian" v-model="header.Waktu_Penyelesaian" required="true" type="text"
                                    :placeholder="$t('completion_time')" v-if="header"
                                    :disabled="true" :useGrouping="false"/>
                                    <small v-if="header && !header.Waktu_Penyelesaian && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('completion_time')) }}
                                     </small>
                            </FormField>

                            <FormField :labelName="$t('company')" fieldName="Company_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Company_Code" :filter="true"  v-if="header"
                                    v-model="header.Company_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/company_Code'"
                                    :minLength="0"
                                    :params="{ docDate: (header.Tanggal_Penerimaan) }" 
                                    :disabled="true"
                                    />
                                    <small v-if="header && !header.Company_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('company')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                    :params="{ docDate: (this.header.Tanggal_Penerimaan != null ? this.header.Tanggal_Penerimaan  : null)}"  
                                    :disabled="true"
                                    />
                                    <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('company_contractor')) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t('Invoice_No')" fieldName="Doc_Header_Text" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Doc_Header_Text" v-model="header.Doc_Header_Text" required="true" type="text" maxlength="25"
                                    :placeholder="$t('Invoice_No')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" @change="onChengeInvoiceNo"/>
                            </FormField>
                            <FormField labelClass="col-4" fieldClass="col-6" v-if="header && !header.hideAdopt">
                                 <Button v-if="header" icon="pi pi-download" label="Adopt SAP" style="width: 120px;" class="p-button mr-2 mr-2" @click="confirmAdoptSAP()" />
                             
                            </FormField>
                            <FormField :labelName="$t('Status_Payment')"  fieldName="Status_Payment" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status_Payment" v-model="header.Status_Payment" required="true" type="text"  v-if="header"
                                    :placeholder="$t('Status_Payment')"
                                    :disabled="true"/>
                            </FormField>
                            
                        </div>  
                        <div class="col-6">
                            
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('tgl_penerimaan')" fieldName="Tanggal_Penerimaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="Tanggal_Penerimaan" v-model="header.Tanggal_Penerimaan" type="text"
                                :placeholder="$t('tgl_penerimaan')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Tanggal_Penerimaan && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('tgl_penerimaan')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('accept_pekerjaan')" fieldName="Status_Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <div class="flex align-items-center">
                                    <RadioButton v-model="header.Status_Pekerjaan" value="Menerima"  v-if="header" :disabled="true"/>
                                    <label for="ingredient1" class="ml-2" style="font-size: 0.9rem"> {{$t('acceptpekerjaan.menerima')}} </label>
                                </div>
                                <div class="flex align-items-center">
                                    <RadioButton v-model="header.Status_Pekerjaan"  value="Tidak Bisa Menerima"  v-if="header" :disabled="true"/>
                                    <label for="ingredient2" class="ml-2" style="font-size: 0.9rem"> {{$t('acceptpekerjaan.tidak_menerima')}} </label>
                                </div>
                            </FormField>
                            
                            <FormField :labelName="$t(labelAppr1)" fieldName="Username_Contractor" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr1">
                                <CustomSelect name="Username_Contractor" :filter="true"  v-if="header"
                                    v-model="header.Username_Contractor" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion: header.Appr_As1, doc_type : this.$TypeDocument.BAST_FINAL,  companycode: header.Company_Code,contractorcode : header.Contractor_Code}" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Contractor && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr1)) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t(labelAppr2)" fieldName="Username_PM" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr2">
                                <CustomSelect name="Username_PM" :filter="true"  v-if="header"
                                    v-model="header.Username_PM" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As2, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.BAST_FINAL, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_PM && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr2)) }}
                                </small>
                            </FormField>
                                
                            <FormField :labelName="$t(labelAppr3)" fieldName="Username_PC" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr3">
                                <CustomSelect name="Username_PC" :filter="true"  v-if="header"
                                    v-model="header.Username_PC" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As3, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.BAST_FINAL, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_PC && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr3)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr4)" fieldName="Username_Head_Unit" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr4">
                                <CustomSelect name="Username_Head_Unit" :filter="true"  v-if="header"
                                    v-model="header.Username_Head_Unit" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As4, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.BAST_FINAL, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Head_Unit && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr4)) }}
                                </small>
                            </FormField>
                           
                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.DONE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| header.Status != this.$APPROVAL_STATUS.DONE"/>
                                    <small v-if="header &&((!header.Reason && header.Status == this.$APPROVAL_STATUS.DONE)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>

                        </div>
                        <div class="col-12">
                            <DataTable v-if="header" :loading="!header" :value="header.Progresses ? header.Progresses : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <template #header>
                                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                                        <span class="text-900 font-bold">Progress</span>
                                    </div>
                                </template>
                                <Column field="Task" :header="$t('task')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('task')" @change="onCellEditCompleteProgress(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" :readonly="true"/>
                                            <br/>
                                            <small v-if="!slotProps.data.Task && submitted2 && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('task')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Unit" :header="$t('unit')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">

                                            <InputNumber v-if="slotProps.data.Task == 'Progress'" :useGrouping="false"
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true" :max="100"
                                                :placeholder="$t('%')" @input="onCellEditCompleteProgress(slotProps);onChangeProgress(slotProps, $event)"  
                                                @blur="onCellEditCompleteProgress(slotProps);"
                                                :disabled="true"
                                                v-show="slotProps.data.mode != 'Delete'" :readonly="slotProps.data.Task != 'Progress'"/>

                                            <InputText v-else
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('unit')" @change="onCellEditCompleteProgress(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" :readonly="slotProps.data.Task != 'Progress'"/>
                                            <br/>
                                            <small v-if="!slotProps.data.Unit && submitted2 && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('unit')) }}
                                            </small>
                                           
                                        </div>
                                    </template>
                                </Column>
                                
                                <Column field="Sch_Date" :header="$t('sch_date')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <DatePicker name="Sch_Date" v-model="slotProps.data[slotProps.column.props.field]"
                                            :placeholder="$t('sch_date')" @date-select="onCellEditCompleteProgress(slotProps);onSelectSchDate(slotProps.data)"
                                            :disabled="true"
                                            v-show="slotProps.data.mode != 'Delete'"/>
                                           
                                            <small v-if="!slotProps.data.Sch_Date && submitted2 && mode != this.$FORM_MODE_DELETE && slotProps.data.Task != 'Retensi'"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('sch_date')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Act_Date" :header="$t('act_date')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <DatePicker name="Act_Date" v-model="slotProps.data[slotProps.column.props.field]"
                                            :placeholder="$t('act_date')" @date-select="onCellEditCompleteProgress(slotProps);onSelectActDate(slotProps.data)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (slotProps.data.Task == 'Progress' && slotProps.data.Sch_Date == null) || slotProps.data.Task == 'Retensi'"
                                            v-show="slotProps.data.mode != 'Delete'"/>
                                        
                                            <small v-if="!slotProps.data.Act_Date && submitted2 && mode != this.$FORM_MODE_DELETE && slotProps.data.Task != 'Retensi'"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('act_date')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Result" :header="$t('result')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <CustomSelect
                                                v-model="slotProps.data[slotProps.column.props.field]" 
                                                :url="$API_URL + 'list/lookup'"
                                                :params="{ group: $LOOKUP_GROUP.PROGRESS_BAST }" 
                                                :minLength="0" 
                                                :filter="true"
                                                @change="onCellEditCompleteProgress(slotProps)"
                                                :disabled="true"
                                                />
                                           
                                            <small v-if="!slotProps.data.Result && submitted2 && mode != this.$FORM_MODE_DELETE && slotProps.data.Task != 'Retensi'"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('result')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Sign" :header="$t('sign')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('sign')" @change="onCellEditCompleteProgress(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || slotProps.data.Task == 'Retensi' || this.header.Status == this.$APPROVAL_STATUS.DONE || true"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Name" :header="$t('name')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('name')" @change="onCellEditCompleteProgress(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || slotProps.data.Task == 'Retensi' || this.header.Status == this.$APPROVAL_STATUS.DONE || true"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                            <br/>
                                            <!-- <small v-if="!slotProps.data.Name && submitted && mode != this.$FORM_MODE_DELETE && slotProps.data.Task != 'Retensi'"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('name')) }}
                                            </small> -->
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div class="col-12">
                            <DataTable v-if="header" :loading="!header" :value="header.Evaluasis ? header.Evaluasis : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <template #header>
                                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                                        <span class="text-900 font-bold">Evaluasi</span>
                                    </div>
                                </template>
                                <Column field="Task" :header="$t('task')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('task')" @change="onCellEditCompleteEvaluasi(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" :readonly="true"/>
                                            <br/>
                                            <small v-if="!slotProps.data.Task && submitted2 && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('task')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Result" :header="$t('result')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <CustomSelect
                                            v-model="slotProps.data[slotProps.column.props.field]" 
                                            :url="$API_URL + 'list/lookup'"
                                            :params="{ group: slotProps.data.Task != 'Kebersihan' ? $LOOKUP_GROUP.EVALUASI_BAST_MUTU : $LOOKUP_GROUP.EVALUASI_BAST_KEBERSIHAN }" 
                                            :minLength="0" 
                                            :filter="true"
                                            @change="onCellEditCompleteEvaluasi(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            />
                                           
                                            <small v-if="!slotProps.data.Result && submitted2 && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('result')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Remarks" :header="$t('remarks')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('remarks')" @change="onCellEditCompleteEvaluasi(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                            <br/>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import moment from 'moment';
import IndexBase from '../Helper/IndexBase.vue'
export default {
    name: "Editor",
    components: {
        IndexBase
    },
    data() {
        return {
            indexName: "BaFinalIndex",
            url: this.$API_URL + "bafinal/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            viewFiles : null,
            evaluasi : null,
            progress : null,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog,
            labelAppr1 : "",
            labelAppr2 : "",
            labelAppr3 : "",
            labelAppr4 : "",
            submitted2 : false,
            onlyDraft: false,
        }
    },
    methods: {
        onChangeProgress(data,e){

            if(e.value != null ){
                e.value = e.value > 100 ? 100 :e.value;
                var getcountDate = e.value /100 * data.data.completiontime;
                var getday = Math.ceil(getcountDate);
                var date = new Date(data.data.startdate);
                date.setHours(0, 0, 0, 0);
                var resultDate = new Date(date.setDate(date.getDate() + getday));
                
                const schDate = resultDate;
                const actDate = new Date(data.data.Act_Date);
                
                if(this.$isNotWIB){    
                    schDate.setHours(0, 0, 0, 0);
                    actDate.setHours(0, 0, 0, 0);
                }
                data.data.Sch_Date =schDate; 
                
                if(schDate >= actDate){
                    data.data.Result = this.$RESULT.ONTARGET;
                }
                else if(schDate < actDate){
                    data.data.Result = this.$RESULT.DELAYED;
                }

            }else{
                data.data.Sch_Date =null; 
            }
           
        },
        onChengeInvoiceNo(){
            this.header.Status_Payment = null;
        },
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },
        onSelectActDate(data){
    
            const schDate = new Date(data.Sch_Date);
            const actDate = new Date(data.Act_Date);


            if(this.$isNotWIB){    
                schDate.setHours(0, 0, 0, 0);
                actDate.setHours(0, 0, 0, 0);
            }

            if(schDate){
                if(schDate >= actDate){
                    data.Result = this.$RESULT.ONTARGET;
                }
                else if(schDate < actDate){
                    data.Result = this.$RESULT.DELAYED;
                }
            }
        },
        onSelectSchDate(data){

            const schDate = new Date(data.Sch_Date);
            const actDate = new Date(data.Act_Date);


            if(this.$isNotWIB){    
                schDate.setHours(0, 0, 0, 0);
                actDate.setHours(0, 0, 0, 0);
            }

            if(actDate){
                if(schDate > actDate){
                    this.showError("Error", "Sch Date greater than Act Date");
                    data.Sch_Date= null;
                }
            }
        },
        doesStringIncludePercent(inputString) {
            return inputString.includes("%");
        },
        getData() {
            var self = this;
            this.$axios.get(this.url + this.mainid + "/" +this.id + "/" + this.mode)
                .then((response) => {

                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }

                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.evaluasi = response.data.data.evaluasi;
                    self.progress = response.data.data.progress;
                    self.detailLog = self.header.DetailLog;
                    self.dataModelChild = response.data.data.header.listChild;
                  
                    var listAppr = response.data.data.listPicAppr;
                    if(listAppr.length > 0)
                    {
                        listAppr.forEach(a=>{
                            if(a.Sign_Position == 1){
                                self.labelAppr1 = a.Approval_As;
                                self.header.Appr_As1 = a.Approval_As;
                                self.header.Sign_Position1 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 2){
                                self.labelAppr2 = a.Approval_As;
                                self.header.Appr_As2 = a.Approval_As;
                                self.header.Sign_Position2 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 3){
                                self.labelAppr3 = a.Approval_As;
                                self.header.Appr_As3 = a.Approval_As;
                                self.header.Sign_Position3 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 4){
                                self.labelAppr4 = a.Approval_As;
                                self.header.Appr_As4 = a.Approval_As;
                                self.header.Sign_Position4 =  a.Sign_Position;
                            }
                        });
                    }

                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        validationFromAdoptSAP(){
            if(!this.header.Doc_Header_Text){
                    this.showError('Error Adopt Data', "Contractor invoice is required for adopt Payment Status");
                    return true;
            }
            else
                return false;
        },
        confirmAdoptSAP(){
            if(this.validationFromAdoptSAP()){
                return;
            }          
            this.adoptSAP();
        },
        adoptSAP(){
            this.$emit('block-ui');
            var self = this;
              
             this.$axios.post(this.url + "adoptSAP", this.header)
                .then((response) => {
                    if (response.data.success) {
                        var dataAdopt = response.data.data;
                        self.header.Status_Payment = dataAdopt.Status_Payment;
                        if(self.header.Status_Payment == "Invoice Invalid")
                        {
                           self.showError('Error', "Invoice Not Found");
                        }else{
                            self.$toast.add({ severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
                        }
                        
                        
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                    self.$emit('unblock-ui');
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
           
            if(this.header){        
                this.header.Tanggal_Penerimaan_String = moment( this.header.Tanggal_Penerimaan).format('YYYY/MM/DD').toString();

                this.header.Progresses.forEach(a=>{
                    if(a.Act_Date){
                        var date = new Date(a.Act_Date);
                        a.Act_Date_String =  moment(date).format('YYYY/MM/DD').toString();
                    
                    }
                    
                    if(a.Sch_Date){
                        var date = new Date(a.Sch_Date);
                        a.Sch_Date_String =   this.$moment(date).format('YYYY/MM/DD').toString()
                    }
                });    
            }

             this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "BA Final has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "BA Final has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            this.submitted2 = true;
            var self = this;
            //!this.header.Username_Contractor || !this.header.Username_PM || !this.header.Username_PC || !this.header.Username_Head_Unit || !this.header.Status_Pekerjaan 
            if(self.mode != this.$FORM_MODE_DELETE){
                
                if (!this.header.Contractor_Code || !this.header.Company_Code||!this.header.Pekerjaan || (this.header.isSpo &&!this.header.No_SPO) ||
                    (this.header.isSpo &&!this.header.Tanggal_SPO) || !this.header.Waktu_Penyelesaian || !this.header.Tanggal_Penerimaan ||
                    (this.labelAppr1 && !this.header.Username_Contractor) || (this.labelAppr2 && !this.header.Username_PM) || (this.labelAppr3 && !this.header.Username_PC) || (this.labelAppr4 && !this.header.Username_Head_Unit)
                    ||(!this.header.Reason && this.header.Status == this.$APPROVAL_STATUS.DONE)) {
                    return;
                }
               
                // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
                //     self.showError("Error", "Must have attachment")
                //     return;
                // }   
                
                if(this.header.Evaluasis.length == 0){
                    self.showError("Error", "Must have one detail evaluasi")
                    return;
                }
                if(this.header.Progresses.length == 0){
                    self.showError("Error", "Must have one detail progress")
                    return;
                }

            }

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            this.submitted2 = false;
            var self = this;
          
            //!this.header.Username_Contractor || !this.header.Username_PM || !this.header.Username_PC || !this.header.Username_Head_Unit || !this.header.Status_Pekerjaan 
            if ( !this.header.Contractor_Code || !this.header.Company_Code||!this.header.Pekerjaan || (this.header.isSpo &&!this.header.No_SPO) ||
                (this.header.isSpo &&!this.header.Tanggal_SPO) || !this.header.Waktu_Penyelesaian || !this.header.Tanggal_Penerimaan) {
                return;
            }

            // if(this.header.Evaluasis.length == 0){
            //     self.showError("Error", "Must have one detail evaluasi")
            //     return;
            // }
            // if(this.header.Progresses.length == 0){
            //     self.showError("Error", "Must have one detail progress")
            //     return;
            // }
            // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
            //     self.showError("Error", "Must have attachment")
            //     return;
            // }   



            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetailEvaluasi() {
            var newDetail = this.evaluasi;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Evaluasis.push(det);
        },
        deleteDetailEvaluasi(event) {
            if (event) {
                var detail = this.header.Evaluasis[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Evaluasis.splice(this.header.Evaluasis.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteEvaluasi(event) {
            this.editDetailEvaluasi(event.index);
        },
        editDetailEvaluasi(index) {
            if (this.header && this.header.Evaluasis) {
                let mode = this.header.Evaluasis[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Evaluasis[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        addDetailProgress() {
            var newDetail = this.progress;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Progresses.push(det);
        },
        deleteDetailProgress(event) {
            if (event) {
                var detail = this.header.Progresses[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Progresses.splice(this.header.Progresses.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteProgress(event) {
            this.editDetailProgress(event.index);
        },
        editDetailProgress(index) {
            if (this.header && this.header.Progresses) {
                let mode = this.header.Progresses[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Progresses[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
                data.files_data = [];
                for(var i = 0; i<event.files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        onDownloadFile(file){
            var self = this;
            this.$axios.get(this.url + "download_attachment/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
    },
    computed:{},
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.mainid = this.$route.query.mainid ?? 0;
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
        this.getData();
    }
}
</script>
<style>
.p-skeleton {
    height: 0 !important;
    display: none !important;
}
</style>